<template lang="pug">
  b-container(fluid="fluid")
    b-row
      b-col
        b-row.border-top.ml-3.mr-1
          b-col(:class="customer_title_col_class") パスワード
          b-col(:class="customer_input_col_class")
            b-form-input.middle-form-size(size="sm", type="password", v-model="local_password.value", :placeholder="local_password.placeholder", :state="local_password.error_msg_list.length === 0 ? null : false")
            b-form-text.align-left.text-left.error-message-color(v-for="(error_msg, key) of local_password.error_msg_list", :key="key") {{error_msg}}
            b-form-text.align-left.text-left ※ログイン時に使用するパスワードです。
            b-form-text.align-left.text-left ※大文字・小文字・数字・記号から少なくとも2種類を含んだ、ご希望の文字列をご設定ください。
        b-row.border-top.ml-3.mr-1
          b-col.border-bottom(:class="customer_title_col_class") パスワード(確認用)
          b-col.border-bottom(:class="customer_input_col_class")
            b-form-input.middle-form-size(size="sm", type="password", v-model="local_re_password.value", :placeholder="local_re_password.placeholder", :state="local_re_password.error_msg_list.length === 0 ? null : false")
            b-form-text.align-left.text-left.error-message-color(v-for="(error_msg, key) of local_re_password.error_msg_list", :key="key") {{error_msg}}
</template>

<script>
export default {
  name: "ChangePasswordForm",
  props: {
    password:    { type: Object, required: true }, // パスワード
    re_password: { type: Object, required: true }, // パスワード確認
  },
  computed: {
    // パスワード
    local_password: {
      get: function() {
        return this.password;
      },
      set: function(value) {
        this.$emit("update:password", value);
      }
    },
    // パスワード確認
    local_re_password: {
      get: function() {
        return this.re_password;
      },
      set: function(value) {
        this.$emit("update:re_password", value);
      }
    }
  },
  data() {
    return {
      title_class: "ml-3 customer-title-bg-color pb-1",
      title_font_class: "font-weight-bold pt-2 mb-0",

      customer_title_col_class: "py-2 px-2 border-right font-weight-bold table-title-col-width",
      customer_input_col_class: "py-2 px-2",
    }
  },
}
</script>

<style scoped>
.customer-title-bg-color {
  background-color: #f5f5f5;
}
.table-title-col-width {
  max-width: 180px;
}
.middle-form-size {
  max-width: 500px;
}
</style>